import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Clock, LogOut } from "lucide-react";

const PendingApproval = () => {
  const { user, logout } = useAuth();
  return (
    <div data-testid="pending-approval-page" className="min-h-screen bg-slate-50 flex items-center justify-center p-6">
      <div className="w-full max-w-lg bg-white border border-slate-200 rounded-sm p-8 space-y-4">
        <div className="h-12 w-12 bg-amber-100 text-amber-800 flex items-center justify-center rounded-sm">
          <Clock className="h-6 w-6" />
        </div>
        <p className="text-[10px] tracking-[0.25em] uppercase text-amber-700 font-semibold">Awaiting approval</p>
        <h1 className="font-heading text-3xl font-bold tracking-tight text-slate-900">
          Hi {user?.name?.split(" ")[0] || "there"}, you’re in the queue.
        </h1>
        <p className="text-sm text-slate-600">
          Your account ({user?.email}) is signed in, but a Director still needs to assign you a role before you
          can access the app. Please reach out to your Director if this is taking a while.
        </p>
        <Button
          variant="outline"
          onClick={logout}
          data-testid="logout-btn"
          className="rounded-sm h-10"
        >
          <LogOut className="h-4 w-4 mr-2" /> Sign out
        </Button>
      </div>
    </div>
  );
};

export default PendingApproval;
